<div [attr.data-test]="'feature-catalogProductPage'">
  <div [appLoadingAnimation]="isAbstractProductLoading$ | async">
    @if (!isSapStore) {
      <app-basic-product-pdp
        (addNewModalWishlist)="addNewModalActive = true"
        (addProductToCartSubmit)="addProductToCart($event)"
        [labels]="labels"
        [installBaseProducts]="installBaseProducts"
        [abstractProduct]="abstractProduct"
        [concreteSku]="concreteSku"
        [loadingCartDataInProgress]="loadingCartDataInProgress"
        [productInfoLoaded]="productInfoLoaded"
        [(productQuantity)]="productQuantity"
        [isAddToCartInProgress$]="isAddToCartInProgress$"
        [isInStore]="isInStore"
        [addNewModalActive]="addNewModalActive"
        [sku]="sku"
        [displayConfig]="displayConfig"
        [showPriceDisclaimer]="showPriceDisclaimer"
        [secondPrice]="secondPrice"
        [defaultPrice]="defaultPrice"
        [housingFee]="housingFee"
        [listPriceWithoutReplacement]="listPriceWithoutReplacement"
        [listPriceWithReplacement]="listPriceWithReplacement"
        [yourPriceWithoutReplacement]="yourPriceWithoutReplacement"
        [yourPriceWithReplacement]="yourPriceWithReplacement"
        [largeUrls]="largeUrls"
        [smallUrls]="smallUrls"
        [defaultImg]="defaultImg"
        [mainPicture]="mainPicture"
        [productDetailsEnum]="productDetailsEnum"
        [wasRedirectedFromEquipmentPage]="wasRedirectedFromEquipmentPage"
        [wishlists]="wishlists"
        [isWishlistsActive]="isWishlistsActive"
        [isProductTagsActive]="isProductTagsActive"
        [isPredefinedEquipmentFlowEnabled]="isPredefinedEquipmentFlowEnabled"
        [isDeliveryAvailabilityEnabled]="isDeliveryAvailabilityEnabled$ | async"
        [isEstimatedDeliveryEnabled]="isEstimatedDeliveryEnabled$ | async">
      </app-basic-product-pdp>
    }
    @if (isUsStore && isCpqEnabled && !isSparePart) {
      <app-configurable-product-pdp
        (addProductToCartSubmit)="addProductToCart($event)"
        [installBaseProducts]="installBaseProducts"
        [abstractProduct]="abstractProduct"
        [productInfoLoaded]="productInfoLoaded"
        [sku]="sku"
        [displayConfig]="displayConfig"
        [defaultImg]="defaultImg"
        [mainPicture]="mainPicture"
        [productDetailsEnum]="productDetailsEnum"
        [contractParams]="contractParams"
        [flNumber]="flNumber"
        [materialNumber]="materialNumber"
        [stepNumber]="stepNumber"
        [concreteProduct]="concreteProduct">
      </app-configurable-product-pdp>
    }
    @if (isSapStore && isSparePartsEnabled && isSparePart) {
      <app-spare-part-product-pdp
        (addNewModalWishlist)="addNewModalActive = true"
        (addProductToCartSubmit)="addProductToCart()"
        [abstractProduct]="abstractProduct"
        [concreteSku]="concreteSku"
        [productInfoLoaded]="productInfoLoaded"
        [isAddToCartInProgress$]="isAddToCartInProgress$"
        [sku]="sku"
        [displayConfig]="displayConfig"
        [defaultImg]="defaultImg"
        [mainPicture]="mainPicture"
        [systemDetails]="systemDetails"
        [equipmentFlNumber]="flNumber"
        [stepNumber]="stepNumber"
        [concreteProduct]="concreteProduct"
        [labels]="labels"
        [loadingCartDataInProgress]="loadingCartDataInProgress"
        [wasRedirectedFromEquipmentPage]="wasRedirectedFromEquipmentPage"
        [(productQuantity)]="productQuantity"
        [addNewModalActive]="addNewModalActive"
        [listPrice]="secondPrice"
        [yourPrice]="defaultPrice"
        [largeUrls]="largeUrls"
        [smallUrls]="smallUrls"
        [wishlists]="wishlists"
        [isWishlistsActive]="isWishlistsActive"
        [isProductTagsActive]="isProductTagsActive"
        [productDetailsEnum]="productDetailsEnum"
        [installBaseProducts]="installBaseProducts"
        [companyRoles]="companyRoles"
        [recentlyOpenedProducts]="recentlyOpenedProducts"
        [isDeliveryAvailabilityEnabled]="isDeliveryAvailabilityEnabled$ | async">
      </app-spare-part-product-pdp>
    }
  </div>
  <app-add-new-wishlist
    [showModal]="addNewModalActive"
    (closeModal)="addNewModalActive = false">
  </app-add-new-wishlist>
  <app-add-item-modal
    [showModal]="addItemToCartModalActive"
    (closeModal)="addItemToCartModalActive = false"
    [items]="itemToAdd"
    [currentCartId]="currentCartId">
  </app-add-item-modal>
  <app-modal-confirm
    [type]="iconType.WARNING"
    modalTitle="{{ 'spare-parts.not-selected-equipment-modal' | translate }}"
    notifyText="{{ 'spare-parts.not-selected-equipment-modal-content' | translate }}"
    cancelBtnText="{{ 'catalog.select-equipment-modal.cancel-btn' | translate }}"
    primaryBtnText="{{ 'catalog.select-equipment-modal.submit-btn' | translate }}"
    [showModalConfirm]="showModalSelectEquipment"
    (closeModalConfirm)="showModalSelectEquipment = false"
    (primaryActionConfirm)="selectEquipment()">
  </app-modal-confirm>
</div>
